import React from 'react'
import { combineClasses } from '~/util'
import { VirtualTourAction } from '../../buttons'
import styles from './EasyIFrameModal.module.scss'
import { EasyIFrameModal, VirtualTourModalProps } from './EasyIFrameModal'

/**
 * A component that renders a "3D Virtual Tour" button that opens an iframe
 * modal containing a virtual tour. This is slightly easier than using the
 * `IFrameModal` and `VirtualTourAction` components together.
 */
export const VirtualTourModal = React.memo(
  ({ actionClassName, actionProps, ...props }: VirtualTourModalProps) => (
    <EasyIFrameModal {...props}>
      {(setIsOpen) => (
        <VirtualTourAction
          data-testid="iframeButton"
          className={combineClasses(styles.iframeButton, actionClassName)}
          button
          feel="button"
          display="primary"
          onClick={() => setIsOpen(true)}
          {...actionProps}
        >
          3D Virtual Tour
        </VirtualTourAction>
      )}
    </EasyIFrameModal>
  )
)
